'use strict';

export default ['$rootScope', 'SecurityService',
    function ($rootScope, SecurityService) {
        $rootScope.title = '';
        // $scope.$watch(
        //     () => SecurityService.getUser(),
        //     () => $scope.name = `${SecurityService.getUser().staff.firstName} ${SecurityService.getUser().staff.surname}`,
        //     true,
        // );
        //$scope.name =  $scope.info ? `${$scope.info.firstName} ${$scope.info.surName}` : 'пользователь';
    }]